export enum PrintVariationType {
  Image,
  Book,
  BusinessCard,
  Certificate,
  GeneralPrint
}
